<template>
	<vx-card no-shadow card-border :title="$t('Routing.Table.Identification') + ' : ' + selectedInfoDetails">
		<!-- NAV BAR VISIT POINT -->
		<vs-navbar :type="'border'" v-model="activeItem" class="nabarx mb-5" square>
			<div slot="title">
				<vs-navbar-title>
					<span class="text-primary">
						{{ $t("OptimizerManager.PointsTotal") + ":" }}
						{{ waypointSelected != null ? waypointSelected.length : 0 }}
					</span>
				</vs-navbar-title>
			</div>
			<vs-navbar-item index="1">
				<a href="#" @click="showPopupWaypoint = true" class="text-center"
					><feather-icon class="cursor-pointer" icon="MapIcon" /><br /><small>{{
						$t("Routing.Map.SeeMap")
					}}</small></a
				>
			</vs-navbar-item>
			<vs-navbar-item index="2">
				<a href="#" @click="waypointListMounted = true" class="text-center"
					><feather-icon class="cursor-pointer" icon="CalendarIcon" /><br /><small>{{
						$t("SelectSchedule")
					}}</small></a
				>
			</vs-navbar-item>
		</vs-navbar>
		<vue-perfect-scrollbar class="scroll-area" :settings="settings">
			<vs-list>
				<list-selected-datarutas-waypoints-item
					v-for="(waypoint, index) in waypointSelected"
					:key="index"
					:waypointItem="waypoint"
					:indexWaypoint="index + 1"
				></list-selected-datarutas-waypoints-item>
			</vs-list>
		</vue-perfect-scrollbar>
		<vs-popup
			class="vs-popup--content-custom"
			style="z-index: 59000"
			:fullscreen="true"
			:title="$t('ListOfSchedules')"
			:active.sync="waypointListMounted"
		>
			<list-schedule-wayoints
				v-if="waypointListMounted"
				:waypointList="waypointSelected"
				:dataFilter="dataFilterWaypoint"
				@closePopupWaypointEmit="closePopupWaypoint"
			/>
		</vs-popup>
		<vs-popup
			id="map-popup-waypoint"
			style="z-index: 59000"
			:title="$t('ListOfSchedules')"
			:active.sync="showPopupWaypoint"
		>
			<waypoint-map
				v-if="showPopupWaypoint"
				:name="'waypoint-map'"
				:data="waypointSelected"
				:zoom="'13'"
				:theme="'uber'"
				:calledFrom="'DinamicFields'"
			/>
		</vs-popup>
	</vx-card>
</template>

<script>
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import ListSelectedDatarutasWaypointsItem from "@/components/optimization/export-waypoint/ListSelectedDatarutasWaypointsItem.vue";
import ListScheduleWayoints from "@/components/optimization/export-waypoint/ListScheduleWayoints.vue";
import WaypointMap from "@/components/optimization/export-waypoint/WaypointMap.vue";

export default {
	components: {
		vSelect,
		VuePerfectScrollbar,
		ListSelectedDatarutasWaypointsItem,
		ListScheduleWayoints,
		WaypointMap,
	},
	props: {
		waypointSelected: {
			type: Array,
			default: () => [],
		},
		dataFilterWaypoint: {
			type: Object,
			default: () => {},
		},
		selectedInfoDetails: "",
	},
	data() {
		return {
			isMounted: false,
			activePrompt: false,
			waypointListMounted: false,
			showPopupWaypoint: false,
			activeItem: 1,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
		};
	},
	mounted() {
		this.isMounted = true;
	},
	created() {
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
	},
	methods: {
		closePopupWaypoint() {
			this.waypointListMounted = false;
			this.$emit("closeScheduleEmit");
		},
	},
};
</script>

<style lang="scss" scoped>
#content-router-selection {
	height: 100%;
}

.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 550px;
	max-height: 500px;
}
.content-form-create {
	width: 100%;
	min-height: 550px;
	max-height: 650px;
}
</style>
<style lang="scss">
#map-popup-waypoint {
	/* Hide the default close button of the InfoWindow */
	.gm-ui-hover-effect {
		display: none !important;
	}
	.custom-info-window {
		padding: 10px;
		background-color: white;
		border: 1px solid #ccc;
		border-radius: 4px;
	}
}
</style>
